import { baseUrl } from './apiUtils';

async function getWeek(weekStart) {
  const response = await fetch(`${baseUrl}public/timetable?weekStart=${encodeURIComponent(weekStart)}`, {
    credentials: 'omit', cache: 'no-store',
  });
  if (!response.ok) throw new Error('Public timetable unavailable');
  return response.json();
}

export default { getWeek };
